<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute,
    }"
    :style="{ padding: isMobile.isMobile ? '10px 15px' : '10px 15px',zIndex:isMobile.isMobile?'9':'999'}"
  >
    <div
      class="md-toolbar-row"
      :class="isMobile.isMobile ? 'md-toolbar-row greenStyle' : 'md-toolbar-row'"
    >
      <div class="md-toolbar-section-start" style="color: #fff" v-if="isMobile.isMobile">
        <span style="display: inline-block; width: 82px"  v-if="$route.path!=='/SimClassDetails'"> {{ routeName().name }}</span>

        <v-btn
          large
          class="md-button md-success"
          style="padding: 0 0"
          v-hasPermi="['dev::course::add']"
          @click="toNewCourse"
          v-if="routeName().path == '/design'"
          :style="{height:routeName().path == '/design'?'35px':'0px'}"
        >
          <span class="iconfont icon-tianjia" style="font-size: 17px; margin-right: 2px"></span
          >新建课程
        </v-btn>

        <span class="iconfont icon-fanhui back" @click="goBack" v-if="isMobile.isMobile&&$route.path=='/SimClassDetails'">
        <md-tooltip md-direction="top" >返回</md-tooltip>
      </span>

      </div>

      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
          :style="{ color: isMobile.isMobile ? '#fff !important' : '' }"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>
       
        <div class="md-collapse">
          <div class="md-autocomplete"></div>
          <md-list>
            <li class="md-list-item">
              <a class="md-list-item-router md-list-item-container md-button-clean dropdown">
                <div class="md-list-item-content help">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon>help</md-icon>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right uiWrap">
                      <li    v-hasPermi="['dev::home::help']">  
                        <a href="http://meta.docs.icubespace.com/#/" target="_blank"
                          >帮助 ( F1 当前页帮助 )</a
                        >
                      </li>
                      <li>
                        <a href="javascript:;" @click="enableBoot">开启引导</a>
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>

            <li class="md-list-item">
              <a
                class="md-list-item-router md-list-item-container md-button-clean dropdown aboutMy"
              >
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon>person</md-icon>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right uiWrap">
                      <li>
                        <a href="javascript:;" @click="$router.push('/mylearning')">我的学习</a>
                      </li>
                      <li>
                        <a href="javascript:;" @click="$router.push('/user')">帐号</a>
                      </li>

                      <li><a href="javascript:;" @click="logout">退出</a></li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import { logout } from '@/api/user';
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['isMobile']),
  },
  data() {
    return {
      selectedEmployee: '',
      employees: [],
    };
  },
  watch: {
    // 监听路由对象$route的变化
    $route: {
      handler: function (to, from) {
        // 路由发生变化时执行的代码
        // console.log('Route changed from', from.path, 'to', to.path);
        this.routeName();
        // 这里可以根据路由变化执行相应的逻辑
      },
      // 设置为深度监听
      deep: true,
    },
  },
  mounted() {},
  methods: {
    toNewCourse() {
      this.$router.push({ path: './newcourse' });
    },

    routeName() {
      let obj = {
        name: '',
        path: '',
      };
      if (this.$route.path == '/design') {
        //课程管理
        obj = {
          name: '课程列表',
          path: '/design',
        };
      } else if (this.$route.path == '/simclass') {
        //数字课堂

        obj = {
          name: '数字课堂',
          path: '/simclass',
        };
      } else if (this.$route.path == '/applymod') {
        //模型申请

        obj = {
          name: '模型申请',
          path: '/applymod',
        };
      } else if (this.$route.path == '/devicelib') {
        //模型申请

        obj = {
          name: '模型资源库',
          path: '/devicelib',
        };
      } else if (this.$route.path == '/resourceLibrary') {
        //模型申请

        obj = {
          name: '媒体资源库',
          path: '/resourceLibrary',
        };
      } else if (this.$route.path == '/resourceLib') {
        //模型申请

        obj = {
          name: '特效资源库',
          path: '/resourceLib',
        };
      } else if (this.$route.path == '/applycomplie') {
        //模型申请

        obj = {
          name: '编译申请',
          path: '/applycomplie',
        };
      }else if (this.$route.path == '/auditcompile') {
        //模型申请

        obj = {
          name: '编译审核',
          path: '/auditcompile',
        };
      }else if (this.$route.path == '/designDetail') {
        //模型申请

        obj = {
          name: '课程管理详情页面',
          path: '/designDetail',
        };
      }
      return obj;
    },
    goBack(){
      this.$router.go(-1);
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    logout() {
      
      localStorage.clear();
      this.$router.push({ name: 'Login' });
      // logout();
    },
    enableBoot() {
      this.$EventBus.$emit('enableBoots');
    },
  },
};
</script>

<style scoped>
.uiWrap {
  padding: 5px 0px;
}

.uiWrap li a {
  display: block;
  text-align: left;
}
.dropdown-menu li > a {
  padding: 10px 0.5rem;
}
.md-transparent {
  z-index: 999;
}

.greenStyle {
  background: #4caf50;
}
.colorStyle {
  background: #fff;
}
</style>
